export default "__VITE_ASSET__DqFt55c3__"